"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var DownloadIcon = function DownloadIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#333F48' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 20 : _ref$size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M9.99984 13.3333L13.3332 9.16658H10.8332V4.16659C10.8332 3.70635 10.4601 3.33325 9.99984 3.33325C9.5396 3.33325 9.1665 3.70635 9.1665 4.16659V9.16658H6.6665L9.99984 13.3333Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M16.6665 14.4018C16.6665 14.7322 16.3986 15.0001 16.0682 15.0001H3.93146C3.60103 15.0001 3.33317 14.7322 3.33317 14.4018V10.0001C3.33317 9.53984 2.96007 9.16675 2.49984 9.16675C2.0396 9.16675 1.6665 9.53984 1.6665 10.0001V15.0001C1.6665 15.9192 2.414 16.6667 3.33317 16.6667H16.6665C17.5857 16.6667 18.3332 15.9192 18.3332 15.0001V10.0001C18.3332 9.53985 17.9601 9.16675 17.4998 9.16675C17.0396 9.16675 16.6665 9.53984 16.6665 10.0001V14.4018Z",
    fill: color
  }));
};

var _default = DownloadIcon;
exports.default = _default;